export function groupBelongsToSelectedSchoolYear(
  group: { schoolYear: string },
  selectedSchoolYearId: string | undefined,
): boolean {
  if (!selectedSchoolYearId) return false;

  const [selectedSchoolYearStart, selectedSchoolYearEnd] = selectedSchoolYearId.split('-').map(Number);
  const [groupSchoolYearStart, groupSchoolYearEnd] = group.schoolYear.split('-').map(Number);

  return selectedSchoolYearStart >= groupSchoolYearStart && selectedSchoolYearEnd <= groupSchoolYearEnd;
}
